import React from "react";
import { Route, Redirect } from 'react-router-dom';

export default function AuthRoute({ component, role, roles = [], ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) =>
                roles.includes(role) ? (
                    React.createElement(component, props)
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login", state: { from: props.location, },
                        }}
                    />
                )
            }
        />
    );
}